/**
 * @prettier
 **/
import React from 'react';

let ExpandMoreIcon = props => (
  <svg {...props}>
    <polygon fill="#393939" points="16.5,8.9 5.5,8.9 11,14.9 	" />
    <path
      fill="#393939"
      d="M11,21.5c5.8,0,10.5-4.7,10.5-10.5S16.8,0.5,11,0.5S0.5,5.2,0.5,11S5.2,21.5,11,21.5z M11,2.5
		c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5S2.5,15.7,2.5,11S6.3,2.5,11,2.5z"
    />
  </svg>
);

ExpandMoreIcon = React.memo(ExpandMoreIcon);
ExpandMoreIcon.displaName = 'ExpandMoreIcon';

export default ExpandMoreIcon;
